import GraphicsLayer from "@arcgis/core/layers/GraphicsLayer";
import {
  useCurrentMapView,
  ArcFeatureLayer,
  ArcGraphicsLayer,
} from "arcgis-react";
import {
  WCC_BOUNDARY_LAYER,
  renderer,
  outsideBoroughPopup,
  errorZoomInPopup,
  isMapCorrectZoomLevel,
  isCoordinatesInsideBorough,
  getAddressCandidateFromMapPoint,
  addressErrorPopup,
  updateLocationAndDropMapMarker,
  loadingPopup,
} from "./mapUtils";
import { WasteLocation } from "@store/storeSlices/wasteDetails";

interface LayersProps {
  locationUpdate: (locationOfWaste: WasteLocation) => void;
}

export const Layers = ({ locationUpdate }: LayersProps) => {
  const mapView = useCurrentMapView();
  const graphicsLayer = new GraphicsLayer();
  mapView.map.add(graphicsLayer);

  const onMapClick = async (event: __esri.ViewClickEvent) => {
    mapView.graphics.removeAll();
    /**
     * disable auto-popup to allow for manually opening popup on map click
     * See: https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-Popup-PopupViewModel.html#autoOpenEnabled
     */ 
    mapView.popupEnabled = false;
    await mapView.openPopup(loadingPopup(event));

    const inBorough = await isCoordinatesInsideBorough(event);
    const correctZoomLevel = isMapCorrectZoomLevel(mapView);
    const pinAddress = await getAddressCandidateFromMapPoint(event.mapPoint);

    if (!inBorough) {
      await mapView.openPopup(outsideBoroughPopup(event));
      return;
    }

    if (!correctZoomLevel) {
      await mapView.openPopup(errorZoomInPopup(event));
      return;
    }

    if (pinAddress === null) {
      await mapView.openPopup(addressErrorPopup(event));
      return;
    }

    updateLocationAndDropMapMarker(mapView, event, pinAddress, locationUpdate);
  };
  const onZoom = () => {
    if (mapView.popup.visible) {
      mapView.closePopup();
    }
  };

  mapView.on("drag", onZoom);
  mapView.on("click", onMapClick);

  return (
    <>
      <ArcFeatureLayer url={WCC_BOUNDARY_LAYER} renderer={renderer} />
      <ArcGraphicsLayer onLayerCreated={() => graphicsLayer} />
    </>
  );
};
